import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "./ui/button";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white shadow-md py-3"
          : "bg-white/95 backdrop-blur-sm py-4"
      }`}
    >
      {/* Top bar with contact info */}
      <div className="bg-[#0056c5] text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:01323925613" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
              <Phone className="h-4 w-4" />
              <span className="hidden sm:inline">01323 925 613</span>
            </a>
            <a href="mailto:contact@smxmedical.co.uk" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
              <Mail className="h-4 w-4" />
              <span className="hidden md:inline">contact@smxmedical.co.uk</span>
            </a>
          </div>
          <div className="text-xs sm:text-sm">
            Emergency Medical Services | Surrey & Sussex
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_smx-medical-redesign/artifacts/h8y6r4xk_Untitled%20%28300%20x%20150%20px%29.png"
              alt="SMX Medical Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("home")}
              className="text-gray-700 hover:text-[#0056c5] font-medium transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-[#0056c5] font-medium transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("training")}
              className="text-gray-700 hover:text-[#0056c5] font-medium transition-colors"
            >
              Training
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="text-gray-700 hover:text-[#0056c5] font-medium transition-colors"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-gray-700 hover:text-[#0056c5] font-medium transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-[#0056c5] hover:bg-[#004399] text-white px-6 py-2"
            >
              Get Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gray-700"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t mt-4">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection("home")}
                className="text-left text-gray-700 hover:text-[#0056c5] font-medium transition-colors py-2"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="text-left text-gray-700 hover:text-[#0056c5] font-medium transition-colors py-2"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("training")}
                className="text-left text-gray-700 hover:text-[#0056c5] font-medium transition-colors py-2"
              >
                Training
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="text-left text-gray-700 hover:text-[#0056c5] font-medium transition-colors py-2"
              >
                About Us
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="text-left text-gray-700 hover:text-[#0056c5] font-medium transition-colors py-2"
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection("contact")}
                className="bg-[#0056c5] hover:bg-[#004399] text-white w-full"
              >
                Get Quote
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
